export const userRolesData = {
  total: 1,
  limit: 10,
  skip: 0,
  data: [
    {
      id: 382,
      email: 'test_email@bmiq.com',
      newEmail: null,
      isVerifiedNewEmail: false,
      oldActivatedEmail: null,
      isVerified: true,
      verifiedDate: '2020-11-17T16:15:17.723Z',
      verifyToken: null,
      verifyExpires: null,
      resetToken: null,
      resetExpires: null,
      lastIpAddress: null,
      currentIpAddress: '66.191.21.97',
      timezone: null,
      accountsExpired: false,
      isWorkFactorChanged: true,
      accountLocked: false,
      credentialsExpired: false,
      accountEnabled: true,
      type: 'patient',
      isUserReminded: 'never-reminded',
      loginAttempts: 0,
      userIdentifier: '893c2c6d89b9fa25b0e21fd9f233710374cc8149_1605629717779@intellihealth.com',
      deduUserId: 364913,
      bmiqUserId: null,
      migratedAt: null,
      migrateMessageShowed: false,
      isSubscribed: true,
      accountAccessToken: '47a02f74f06fad0a7dce2db17be7c9',
      allowedFeatures: null,
      createdAt: '2020-11-17T16:13:56.130Z',
      updatedAt: '2020-11-18T16:49:19.981Z',
      createdBy: 1,
      updatedBy: 382,
      user_detail: {
        fullName: 'Melanie Mendelssohn',
        id: 700,
        firstName: 'Melanie',
        lastName: 'Mendelssohn',
        gender: null,
        birthDate: '1976-08-09',
        city: null,
        userId: 382,
        addressLine1: null,
        addressLine2: null,
        mobilePhone: null,
        homePhone: null,
        extension: null,
        termId: 1,
        accountInfoStatus: 1,
        createdAt: '2020-11-17T16:13:56.178Z',
        updatedAt: '2020-11-17T16:15:17.813Z',
        createdBy: 1,
        updatedBy: 1,
        countryId: null,
        stateId: null,
        zipCodeId: null,
      },
      organizations_users: [],
      permissions: [
        'api/providers:get',
        'api/providers:find',
        'api/recommendation-to-user:find',
        'api/states:find',
        'api/questionnaire/:id?:create',
        'api/patients:get',
        'api/patients:update',
        'api/patients:patch',
        'api/patient-answers:find',
        'api/providers/:providerId/availability:find',
        'api/patient-meta-data:remove',
        'api/patient-meta-data:find',
        'api/patient-meta-data:create',
        'api/activity-manager:create',
        'api/widgets:find',
        'api/countries:find',
        'api/nutritionix:get',
        'api/system-messages:find',
        'api/diagnosis-symptoms:find',
        'api/icons:find',
        'api/medications:find',
        'api/files:get',
        'api/files:find',
        'api/files:create',
        'api/food-logs:get',
        'api/food-logs:remove',
        'api/food-logs:update',
        'api/food-logs:find',
        'api/food-logs:create',
        'api/appointments:find',
        'api/appointments:create',
        'api/google:remove',
        'api/google:find',
        'api/google:create',
        'api/user-courses:find',
        'api/messages:find',
        'api/goal-categories:get',
        'api/goal-categories:find',
        'api/dedu-login:create',
        'api/exercises:find',
        'api/conversations:find',
        'api/fda:find',
        'api/appointment-types:find',
        'api/zip-codes:find',
        'api/exercise-logs:remove',
        'api/exercise-logs:find',
        'api/exercise-logs:create',
        'api/check-authentication:create',
        'api/video-conference:get',
        'api/video-conference:find',
        'api/video-conference:patch',
        'api/patient-goals:create',
        'api/patient-goals:patch',
        'api/patient-goals-xref:find',
      ],
      roles: [
        {
          name: 'Patient',
          userRoleId: 319,
          group: 'Patient',
        },
      ],
    },
  ],
  roles: {
    name: 'Physician',
    userRoleId: 332,
    group: 'Provider',
    slug: 'provider_physician_admin',
  },
};
export const roles = [
  {
    id: 14,
    name: 'No Permission',
    slug: 'ih_none',
    description: 'User with no permissions; used to keep data integrity and track system-performed activities',
    parentId: null,
    group: 'Admin',
    createdAt: '2020-12-22T16:08:55.846Z',
    updatedAt: '2020-12-22T16:08:55.846Z',
    createdBy: null,
    updatedBy: null,
    role_permissions: [],
  },
];
